module.exports = __webpack_public_path__ + "img/aboutus-evgenia-image.6aa1a7da.png";